var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.beginVisible,
            width: "840px",
            "show-close": false,
            "close-on-click-modal": false,
            title: " "
          },
          on: {
            "update:visible": function($event) {
              _vm.beginVisible = $event
            }
          }
        },
        [
          _vm.products.length > 0
            ? _c(
                "div",
                { staticClass: "cp-tabs" },
                _vm._l(_vm.products, function(p, i) {
                  return _c(
                    "span",
                    {
                      key: p.productId,
                      class: ["cp-tab", { active: _vm.beginActiveIndex === i }],
                      on: {
                        click: function($event) {
                          _vm.beginActiveIndex = i
                        }
                      }
                    },
                    [_vm._v(_vm._s(p.productName))]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.products, function(p, i) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.beginActiveIndex === i,
                    expression: "beginActiveIndex === i"
                  }
                ],
                key: "b-" + p.productId
              },
              [
                _c("h3", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("开始对练前，请了解店铺产品")
                ]),
                _vm._v(" "),
                _vm._l(p.imageUrls, function(url) {
                  return _c("img", {
                    key: url,
                    staticClass: "cp-img",
                    attrs: { src: url }
                  })
                })
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium" },
                  on: { click: _vm.onBeginConfirm }
                },
                [_vm._v("我已知晓，确认后进入对练")]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.orderVisible,
            width: "840px",
            title: "产品须知"
          },
          on: {
            "update:visible": function($event) {
              _vm.orderVisible = $event
            }
          }
        },
        [
          _vm.products.length > 0
            ? _c(
                "div",
                { staticClass: "cp-tabs" },
                _vm._l(_vm.products, function(p, i) {
                  return _c(
                    "span",
                    {
                      key: p.productId,
                      class: ["cp-tab", { active: _vm.orderActiveIndex === i }],
                      on: {
                        click: function($event) {
                          _vm.orderActiveIndex = i
                        }
                      }
                    },
                    [_vm._v(_vm._s(p.productName))]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.products, function(p, i) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.orderActiveIndex === i,
                    expression: "orderActiveIndex === i"
                  }
                ],
                key: "o-" + p.productId
              },
              _vm._l(p.imageUrls, function(url) {
                return _c("img", {
                  key: url,
                  staticClass: "cp-img",
                  attrs: { src: url }
                })
              }),
              0
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-175ddb66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-175ddb66","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/components/CourseProductModal.vue
// module id = 1720
// module chunks = 0